import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { Vendor } from 'src/@types';
import { Project } from 'new/entities/Project';

type UseEntities = {
  data: any;
  getDataSchemaById: (nexsetId: string) => any;
  getFlowNodeById: (id: string) => any;
  getVendorById: (id: number) => Vendor;
  getProjectById: (projectId: string) => Project;
  getAllFlowNodes: () => Record<number, any>;
  getAllSources: () => Record<number, any>;
  getSourceByFlowId: (flowId: string) => Record<string, any> | undefined;
};

const allSourcesSelector = (s: any) => s.entities?.sources;
const allFlowNodesSelector = (s: any) => s.entities?.flowNodes;

/**
 * Access entities or pass a 'path' param and get an exact entity map
 * @param path the path to access the entities map (ex.: flowNodes, projects, dataSetSchemas.123213)
 * @returns
 */
export default function useEntities(path = ''): UseEntities {
  const entities = useSelector((state: any) => state.entities);
  const data = path ? get(entities, path) : entities;
  const allSourcesMap = useSelector(allSourcesSelector);
  const allFlowNodesMap = useSelector(allFlowNodesSelector);

  const getAllSources = () => allSourcesMap;
  const getAllFlowNodes = () => allFlowNodesMap;
  const getFlowNodeById = (id: string) => allFlowNodesMap[id];

  function getDataSchemaById(nexsetId) {
    return data.dataSetSchemas?.[nexsetId];
  }

  function getVendorById(id) {
    return entities.vendors?.[id];
  }

  function getProjectById(projectId) {
    return entities.projects?.[projectId];
  }

  const getSourceByFlowId = (flowId: string) => {
    const allSourcesList = Object.values(allSourcesMap || {});
    return allSourcesList.find((src: any) => src.flow_node_id === flowId);
  };

  return {
    data,
    getDataSchemaById,
    getFlowNodeById,
    getVendorById,
    getProjectById,
    getAllFlowNodes,
    getAllSources,
    getSourceByFlowId,
  };
}
